import { useAuth0 } from '@auth0/auth0-react';
import { store } from 'stores/Store';
const useExternalApiService = (baseURL) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const getAccessToken = async () => {

    try {
      const token = await getAccessTokenSilently();
      //console.log('Access Token procured = ', token);
      return token;
    } catch (error) {
      console.error('Error getting access token:', error);
      throw error;
    }
  };

  const getData = async (endpoint) => {

    if (!isAuthenticated) return;

    try {
      const token = await getAccessToken();
      const response = await fetch(`${baseURL}${endpoint}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (!response.ok) {
        throw new Error(`Error fetching data: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  };

  const postData = async (endpoint, data, signal) => {

    if (!isAuthenticated) return;

    try {
      const token = await getAccessToken();
      const response = await fetch(`${baseURL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        signal
      });
      if (!response.ok) {
        throw new Error(`Error posting data: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  };

  const patchData = async (endpoint, data, signal) => {

    if (!isAuthenticated) return;

    try {
      const token = await getAccessToken();
      const response = await fetch(`${baseURL}${endpoint}`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        signal
      });
      if (!response.ok) {
        throw new Error(`Error posting data: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  };

  const putData = async (endpoint, data, signal) => {

    if (!isAuthenticated) return;

    try {
      const token = await getAccessToken();
      const response = await fetch(`${baseURL}${endpoint}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        signal
      });
      if (!response.ok) {
        throw new Error(`Error posting data: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  };

  const deleteData = async (endpoint, signal) => {

    if (!isAuthenticated) return;

    try {
      const token = await getAccessToken();
      const response = await fetch(`${baseURL}${endpoint}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        signal
      });
      if (!response.ok) {
        throw new Error(`Error posting data: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  };

  const postDataWithFormData = async (endpoint, data, signal) => {
    try {
      const token = await getAccessToken();
          // Post the form data to the API
      const response = await fetch(`${baseURL}${endpoint}`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            // 'Content-Type': 'multipart/form-data'
          },
          body: data,
          signal
      })

      if (!response.ok) {
        throw new Error(`Error posting data: ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  };

  const loadPractitionerGoals = async () => {

    if (!isAuthenticated) return;


    const endpoint = '/api/e/call_winback_goals_by_email';
    const data = {
      fmc_email: store.impersonatedUser 
    }
    
    try {
      const token = await getAccessToken();
      const response = await fetch(`${baseURL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) {
        throw new Error(`Error posting data: ${response.statusText}`);
      }

      const res = await response.json()
      store.setPractitionerGoals(res.payload)
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  };

  const loadFMCInfo = async () => {

    if (!isAuthenticated) return;
    console.log("store.impersonatedUser=", store.impersonatedUser)
    const endpoint = '/api/e/call_winback_get_fmc_info';
    const data = {
      fmc_email: store.impersonatedUser 
    }
    store.setInitialLatLon();
    try {
      const token = await getAccessToken();
      const response = await fetch(`${baseURL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) {
        console.error('Error loading FMC Info');
        // throw new Error(`Error posting data: ${response.statusText}`);
      }

      const res = await response.json()
      //store.setPractitionerGoals(res.payload)
      store.setImpersonatedUserName(res.fmc_name);
      store.setImpersonatedNetsuiteID(res.fmc_netsuite_id);
      store.setImpersonatedRsdName(res.rsd);
      store.setImpersonatedRsdEmail(res.rsd_email);
      store.setImpersonatedUserAlias(res.alias);
      const [lat, lon] = res?.latLon;
      if (lat && lon)  {
        console.log("Loaded latlon", lat, lon);
        store.setInitialLatLon([parseFloat(lat), parseFloat(lon)]);
      }
      console.log("res:", res);
      console.log("Name=", store.impersonatedUserName);
      console.log("NetsuiteID=", store.impersonatedUserNetsuiteID);
      console.log("RSD=", store.impersonatedUserRsdName);
      console.log("RSD Email=", store.impersonatedUserRsdEmail);
      console.log("Store's alias=", store.impersonatedUserAlias);
    } catch (error) {
      console.error('Error loading FMC Info', error);
      // throw error;
    }
  };

  return { getData, postData, postDataWithFormData, loadPractitionerGoals, loadFMCInfo, patchData, deleteData, putData };
}



export default useExternalApiService;